import PropTypes from "prop-types";
import Drawer from "@components/ui-components/drawer";
import StatusChip from "@components/ui-components/status-chip";
import { formatCurrency } from "@src/utility/helpers/utils";
import { KYC_LABEL, KYC_TONE, PAYOUT_STAGE_LABEL, PAYOUT_STAGE_TONE } from "@src/utility/constants/panel/common";

const Row = ({ label, children }) => (
    <div>
        <div className="text-xs text-muted">{label}</div>
        <div className="font-medium text-gray-900">{children}</div>
    </div>
);

Row.propTypes = {
    label   : PropTypes.string.isRequired,
    children: PropTypes.node
};

const PublisherDetailDrawer = ({ open, onClose, publisher, currency }) => (
    <Drawer open={open} onClose={onClose} title={publisher?.holder_name || "Publisher"}>
        {publisher && (
            <div className="space-y-4 py-5">
                <div className="flex items-center gap-2">
                    <StatusChip tone={KYC_TONE[publisher.kyc_status] || "neutral"} label={KYC_LABEL[publisher.kyc_status] || publisher.kyc_status} />
                    <StatusChip tone={PAYOUT_STAGE_TONE[publisher.payout_stage] || "neutral"} label={PAYOUT_STAGE_LABEL[publisher.payout_stage] || publisher.payout_stage} />
                </div>
                <Row label="Amount">{formatCurrency(publisher.pending_amount, currency)}</Row>
                {publisher.confirmation_id && (
                    <Row label="Confirmation ID">{publisher.confirmation_id}</Row>
                )}
            </div>
        )}
    </Drawer>
);

PublisherDetailDrawer.propTypes = {
    open     : PropTypes.bool.isRequired,
    onClose  : PropTypes.func.isRequired,
    publisher: PropTypes.object,
    currency : PropTypes.string
};

export default PublisherDetailDrawer;
